import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import RoleProtectedRoute from '../components/Authentication/RoleProtectedRoute';
import { useSelector } from 'react-redux';
import { ROLES } from '../common/constants';
import DashboardContainer from '../pages/Dashboard/DashboardContainer';
import RrbTable from '../pages/Dashboard/ConrolAdmin/RrbTable';
import CitiesTable from '../pages/Dashboard/ConrolAdmin/CitiesTable';
import PerfomaSubmission from '../pages/PerfomaSubmission';
import CenterCoordinateExamsAdmin from '../pages/Exams/CenterCoordinateExamsAdmin';
import ReportsAdmin from '../pages/Exams/ReportsAdmin';
import ExamSaveSubStats from '../pages/Dashboard/ConrolAdmin/ExamSaveSubStats';
import NodalShiftWiseAttendance from '../pages/Nodal/NodalShiftWiseAttendance';
import ParentMinistryReportPage from '../pages/MinistryReportPages/ParentMinistryReportPage';

const Login = lazy(() => import('../pages/Authentication/Login'));
const Logout = lazy(() => import('../pages/Authentication/Logout'));
const Dashboard = lazy(() => import('../pages/Dashboard/Dashboard'));
const Exams = lazy(() => import('../pages/Exams'));
const AddEditExam = lazy(() => import('../pages/Exams/EditExam'));
const ExamReport = lazy(() => import('../pages/ExamReport/ExamReport'));

const Divisions = lazy(() => import('../pages/Setup/Divisions'));
const Division = lazy(() =>
  import('../pages/Dashboard/ConrolAdmin/DivisionTable')
);
const Cities = lazy(() => import('../pages/Setup/Cities'));
const Centers = lazy(() => import('../pages/Setup/Centers'));
const Users = lazy(() => import('../pages/Setup/Users'));
const Posts = lazy(() => import('../pages/Setup/Posts'));
const Rrb = lazy(() => import('../pages/Setup/Rrb'));
const Dashboards = lazy(() => import('../pages/Setup/Rrb/Rrbs'));
const UsersTable = lazy(() =>
  import('../pages/Dashboard/ConrolAdmin/UsersTable')
);
const CentersTable = lazy(() =>
  import('../pages/Dashboard/ConrolAdmin/CentersTable')
);
const LogsTable = lazy(() =>
  import('../pages/Dashboard/ConrolAdmin/LogsTable')
);
const ExamsTable = lazy(() =>
  import('../pages/Dashboard/ConrolAdmin/ExamsTable')
);
const MinistryExamsTable = lazy(() =>
  import('../pages/Dashboard/ConrolAdmin/MinistryExamsTable')
);

const ReportsTable = lazy(() =>
  import('../pages/Dashboard/ConrolAdmin/ReportsTable')
);
const ZonesTable = lazy(() =>
  import('../pages/Dashboard/SuperAdmin/ZonesTable')
);

//comment
const Notifications = lazy(() => import('../pages/Setup/Notifications/Notif'));
const PaneltyTable = lazy(() =>
  import('../pages/Dashboard/SuperAdmin/PenaltyTable')
);
const FeedbackDashboard = lazy(() =>
  import('../pages/Dashboard/FeedbackDashboard')
);
const SuperAdminFeedbacks = lazy(() =>
  import('../pages/Dashboard/SuperAdminFeedbacks')
);
const PreviewExam = lazy(() => import('../pages/Exams/PreviewExam'));

const CenterCoordinateExams = lazy(() =>
  import('../pages/Exams/CenterCoordinateExams')
);
const CenterCoordinateExamsCompleted = lazy(() =>
  import('../pages/Exams/CenterCoordinateExamsCompleted')
);
const Reports = lazy(() => import('../pages/Exams/Reports'));
const Incidents = lazy(() => import('../pages/Incidents'));
const NoddleExam = lazy(() => import('../pages/Setup/NoddleExam'));
const IncidentReport = lazy(() => import('../pages/Dashboard/IncidentReport'));
const IncidentListing = lazy(() =>
  import('../pages/MinistryReportPages/IncidentListing')
);
const TimeTracker = lazy(() =>
  import('../pages/MinistryReportPages/TimeTracker')
);
const MonitoringReportDashboard = lazy(() =>
  import('../pages/MinistryReportPages/MonitoringReportDashboard')
);

const unauthorizedRoutes = [
  {
    path: '/',
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: 'logout',
        element: <Logout />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to='/' replace={true} />,
  },
];

const authorizedRoutes = (auth, role) => {
  const userRole = auth?.role; // Extract user role from auth object
  console.log('role', role);
  return [
    {
      path: '/',
      element: <ProtectedRoute redirectPath={'/login'} auth={auth} />,
      children: [
        {
          index: true,
          element: <Dashboard />,
        },
        {
          path: 'dashboard',
          element: <Dashboard />,
        },
        {
          path: 'rrb-dashboards',
          element: (
            <RoleProtectedRoute
              allowedRoles={['super-admin']}
              userRole={role.slug}
            >
              <Dashboards />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'recruitment_boards/dashboard/:id',
          element: (
            <RoleProtectedRoute
              allowedRoles={['super-admin']}
              userRole={role.slug}
            >
              <DashboardContainer />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'ministry_exams',
          element: (
            <RoleProtectedRoute
              allowedRoles={['super-admin']}
              userRole={role.slug}
            >
              <NoddleExam />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'nodal_exams',
          element: (
            <RoleProtectedRoute allowedRoles={['admin']} userRole={role.slug}>
              <NoddleExam />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'exams',
          element: (
            <RoleProtectedRoute
              allowedRoles={[
                'admin',
                'member-secretary',
                'deputy-secretary',
                'assistant-secretary',
                'center-coordinator',
              ]}
              userRole={role.slug}
            >
              {role.slug === ROLES.CENTER_COORDINATOR ? (
                <CenterCoordinateExams />
              ) : (
                <Exams />
              )}
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'exams_report',
          element: (
            <RoleProtectedRoute allowedRoles={['admin']} userRole={role.slug}>
              <CenterCoordinateExamsAdmin />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'mreports',
          element: (
            <RoleProtectedRoute
              allowedRoles={['super-admin']}
              userRole={role.slug}
            >
              <ParentMinistryReportPage />
            </RoleProtectedRoute>
          ),
        },
        // {
        //   path: 'ttracker',
        //   element: (
        //     <RoleProtectedRoute
        //       allowedRoles={['super-admin']}
        //       userRole={role.slug}
        //     >
        //       <TimeTracker />
        //     </RoleProtectedRoute>
        //   ),
        // },
        // {
        //   path: 'mincidents',
        //   element: (
        //     <RoleProtectedRoute
        //       allowedRoles={['super-admin']}
        //       userRole={role.slug}
        //     >
        //       <IncidentListing />
        //     </RoleProtectedRoute>
        //   ),
        // },
        {
          path: '/incidents',
          element: (
            <RoleProtectedRoute
              allowedRoles={[
                'admin',
                'member-secretary',
                'deputy-secretary',
                'assistant-secretary',
              ]}
              userRole={role.slug}
            >
              <Incidents />
            </RoleProtectedRoute>
          ),
        },
        {
          path: '/completed-exams',
          element: (
            <RoleProtectedRoute
              allowedRoles={['center-coordinator']}
              userRole={role.slug}
            >
              <CenterCoordinateExamsCompleted />
            </RoleProtectedRoute>
          ),
        },
        {
          path: '/reports/:id',
          element: (
            <RoleProtectedRoute
              allowedRoles={['center-coordinator']}
              userRole={role.slug}
            >
              <Reports />
            </RoleProtectedRoute>
          ),
        },
        {
          path: '/reports_admin/:id/:center_cordinator_id',
          element: (
            <RoleProtectedRoute allowedRoles={['admin']} userRole={role.slug}>
              <ReportsAdmin />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'exams/add',
          element: (
            <RoleProtectedRoute
              allowedRoles={[
                'admin',
                'member-secretary',
                'deputy-secretary',
                'assistant-secretary',
              ]}
              userRole={role.slug}
            >
              <AddEditExam />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'exams/edit/:id',
          element: (
            <RoleProtectedRoute
              allowedRoles={[
                'admin',
                'member-secretary',
                'deputy-secretary',
                'assistant-secretary',
              ]}
              userRole={role.slug}
            >
              <AddEditExam />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'exams/edit/:id/:rrb_id',
          element: (
            <RoleProtectedRoute
              allowedRoles={[
                'admin',
                'super-admin',
                'member-secretary',
                'deputy-secretary',
                'assistant-secretary',
              ]}
              userRole={role.slug}
            >
              <AddEditExam />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'exams/preview/:id',
          element: (
            <RoleProtectedRoute
              allowedRoles={[
                'admin',
                'member-secretary',
                'deputy-secretary',
                'assistant-secretary',
                'super-admin',
              ]}
              userRole={role.slug}
            >
              <PreviewExam />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'exams/reports/:id',
          element: (
            <RoleProtectedRoute
              allowedRoles={[
                'super-admin',
                'admin',
                'member-secretary',
                'deputy-secretary',
                'assistant-secretary',
                'region-coordinator',
                'additional-region-coordinator',
                'control-admin',
              ]}
              userRole={role.slug}
            >
              <ExamReport />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'divisions',
          element: (
            <RoleProtectedRoute
              allowedRoles={[
                'admin',
                'member-secretary',
                'deputy-secretary',
                'assistant-secretary',
              ]}
              userRole={role.slug}
            >
              <Divisions />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'cities',
          element: (
            <RoleProtectedRoute
              allowedRoles={[
                'admin',
                'member-secretary',
                'deputy-secretary',
                'assistant-secretary',
              ]}
              userRole={role.slug}
            >
              <Cities />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'centers',
          element: (
            <RoleProtectedRoute
              allowedRoles={[
                'admin',
                'member-secretary',
                'deputy-secretary',
                'assistant-secretary',
              ]}
              userRole={role.slug}
            >
              <Centers />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'users',
          element: (
            <RoleProtectedRoute
              allowedRoles={[
                'admin',
                'member-secretary',
                'super-admin',
                'deputy-secretary',
                'assistant-secretary',
                'director-general',
                'additional-member-staff',
                'executive-director-establishment',
                'establishment-director-i',
                'establishment-director-ii',
                'deputy-director',
              ]}
              userRole={role.slug}
            >
              <Users />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'posts',
          element: (
            <RoleProtectedRoute
              allowedRoles={[
                'super-admin',
                'director-general',
                'additional-member-staff',
                'executive-director-establishment',
                'establishment-director-i',
                'establishment-director-ii',
                'deputy-director',
              ]}
              userRole={role.slug}
            >
              <Posts />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'recruitment_boards',
          element: (
            <RoleProtectedRoute
              allowedRoles={[
                'super-admin',
                'director-general',
                'additional-member-staff',
                'executive-director-establishment',
                'establishment-director-i',
                'establishment-director-ii',
                'deputy-director',
              ]}
              userRole={role.slug}
            >
              <Rrb />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'control_users',
          element: (
            <RoleProtectedRoute
              allowedRoles={['control-admin']}
              userRole={role.slug}
            >
              <UsersTable />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'saved_submitted_stats',
          element: (
            <RoleProtectedRoute
              allowedRoles={['control-admin']}
              userRole={role.slug}
            >
              <ExamSaveSubStats />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'divisions/control',
          element: (
            <RoleProtectedRoute
              allowedRoles={['control-admin']}
              userRole={role.slug}
            >
              <Division />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'control_centers',
          element: (
            <RoleProtectedRoute
              allowedRoles={['control-admin']}
              userRole={role.slug}
            >
              <CentersTable />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'control_loginactivity',
          element: (
            <RoleProtectedRoute
              allowedRoles={['control-admin']}
              userRole={role.slug}
            >
              <LogsTable />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'control_exams',
          element: (
            <RoleProtectedRoute
              allowedRoles={['control-admin']}
              userRole={role.slug}
            >
              <ExamsTable />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'control_zones',
          element: (
            <RoleProtectedRoute
              allowedRoles={['control-admin']}
              userRole={role.slug}
            >
              <ZonesTable />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'control_cities',
          element: (
            <RoleProtectedRoute
              allowedRoles={['control-admin']}
              userRole={role.slug}
            >
              <CitiesTable />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'control_rrbs',
          element: (
            <RoleProtectedRoute
              allowedRoles={['control-admin']}
              userRole={role.slug}
            >
              <RrbTable />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'control_ministry_exams',
          element: (
            <RoleProtectedRoute
              allowedRoles={['control-admin']}
              userRole={role.slug}
            >
              <MinistryExamsTable />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'control_reports',
          element: (
            <RoleProtectedRoute
              allowedRoles={['control-admin', 'admin']}
              userRole={role.slug}
            >
              <ReportsTable />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'controlreports',
          element: (
            <RoleProtectedRoute
              allowedRoles={['control-admin', 'admin']}
              userRole={role.slug}
            >
              <ReportsTable />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'zones',
          element: (
            <RoleProtectedRoute
              allowedRoles={['super-admin']}
              userRole={role.slug}
            >
              <ZonesTable />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'penalty',
          element: (
            <RoleProtectedRoute
              allowedRoles={['super-admin']}
              userRole={role.slug}
            >
              <PaneltyTable />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'notifications',
          element: <Notifications />,
        },
        {
          path: 'feedbacks',
          element: (
            <RoleProtectedRoute
              allowedRoles={['admin', 'super-admin']}
              userRole={role.slug}
            >
              <FeedbackDashboard />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'overall_feedback',
          element: (
            <RoleProtectedRoute
              allowedRoles={['super-admin']}
              userRole={role.slug}
            >
              <SuperAdminFeedbacks />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'incidence_report',
          element: (
            <RoleProtectedRoute
              allowedRoles={['super-admin', 'admin']}
              userRole={role.slug}
            >
              <IncidentReport />
            </RoleProtectedRoute>
          ),
        },
        {
          path: 'peroforma-submission',
          element: (
            <RoleProtectedRoute
              allowedRoles={['super-admin', 'admin']}
              userRole={role.slug}
            >
              <PerfomaSubmission />
            </RoleProtectedRoute>
          ),
        },
        {
          // nodal shift wise attendance
          path: 'nshift-wise-attendance',
          element: (
            <RoleProtectedRoute allowedRoles={['admin']} userRole={role.slug}>
              <NodalShiftWiseAttendance />
            </RoleProtectedRoute>
          ),
        },

        {
          path: 'logout',
          element: <Logout />,
        },
      ],
    },
    {
      path: '*',
      element: <Navigate to='/' replace={true} />,
    },
  ];
};
export const Routes = (auth) => {
  const authSelector = useSelector((state) => state.rrb.authUserReducer);
  return auth ? authorizedRoutes(auth, authSelector?.role) : unauthorizedRoutes;
};
